// extracted by mini-css-extract-plugin
export var childFlex = "index-module--childFlex--psz6b";
export var childShrink = "index-module--childShrink--yg29s";
export var container = "index-module--container--YBddT";
export var ctaTextLink = "index-module--ctaTextLink--QpSeM";
export var descriptionBlock = "index-module--descriptionBlock--T+GeG";
export var imageBox = "index-module--imageBox--GG9G+";
export var label = "index-module--label--ZkmQJ";
export var subtitle = "index-module--subtitle--el+zl";
export var withCta = "index-module--withCta---dPnf";